import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
// import { useHistory } from "react-router-dom";
// import QueryString from "query-string";
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";

import ResetPasswordForm from "./ResetPasswordForm";
import { sendResetPasswordEmail } from "../../modules";
import { AppStateDisplay, clearAll } from "../../../common";
import strings from "../../../../res/strings";

import styled from "styled-components";
const Panel = styled.div`
  background: rgba(255, 255, 255, 0.15);
  height: 100vh;
`;

let ResetPasswordPanel = (props) => {
  const submitSendResetPasswordEmail = (values) => {
    props.sendResetPasswordEmail(
      {
        values,
        successState: {
          notificationType: "banner",
          title:
            strings.lib_authentication_state_success_send_reset_password_email,
          message:
            strings.lib_authentication_state_success_send_reset_password_email_details,
          redirects: [
            {
              label: strings.lib_authentication_redirect_login_back,
              onClick: () => {
                props.clearAll();
                props.setRightPanel("LOGIN");
              },
            },
          ],
        },
        errorState: {
          notificationType: "banner",
          context:
            "lib_authentication.sendResetPasswordEmail.resetPasswordPage",
          title:
            strings.lib_authentication_state_error_send_reset_password_email,
          message: strings.lib_common_state_error,
          redirects: [
            {
              label:
                strings.lib_authentication_action_send_reset_password_email_retry,
              path: "#",
            },
            {
              label: strings.lib_authentication_redirect_login_back,
              onClick: () => {
                props.setRightPanel("LOGIN");
              },
            },
          ],
        },
      },
      props.history
    );
  };

  return (
    <Panel>
      <AppStateDisplay
        parsedQuery={props.parsedQuery}
        setRightPanel={props.setRightPanel}
      >
        {!props.success && !props.error && (
          <div>
            <ResetPasswordForm
              onSubmit={submitSendResetPasswordEmail}
              setRightPanel={props.setRightPanel}
            />
          </div>
        )}
      </AppStateDisplay>
    </Panel>
  );
};

const mapStateToProps = (state) => ({
  success: state.lib_application.success,
  error: state.lib_application.error,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      sendResetPasswordEmail,
      clearAll,
    },
    dispatch
  );

ResetPasswordPanel = connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPasswordPanel);

export { ResetPasswordPanel };

const ResetPasswordPage = (props) => {
  // const history = useHistory();
  // const parsedQuery = QueryString.parse(props.location.search);

  useEffect(() => {
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>{strings.lib_authentication_title_reset_password}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        {/* <AppStateDisplay parsedQuery={parsedQuery}>
          {!props.success && !props.error && (
            <div>
              <IonText color="primary">
                <ResetPasswordInstructions>
                  {strings.lib_authentication_instruction_reset_password}
                </ResetPasswordInstructions>
              </IonText>
              <ResetPasswordForm onSubmit={submitSendResetPasswordEmail} />
            </div>
          )}
        </AppStateDisplay> */}
      </IonContent>
    </IonPage>
  );
};

export default ResetPasswordPage;
